import * as React from 'react';
import { Button, SpaceBetween } from '@amzn/awsui-components-console';
import { useStore } from 'src/stores/store';
import { Store } from 'src/stores/store.interface';
import { getUndoShortcut, getRedoShortcut } from 'src/utils/CommonUtils';

export default function CanvasActionButtons() {
	const autoLayoutVertical = useStore(
		(state: Store) => state.autoLayoutVertical
	);
	const autoLayoutHorizontal = useStore(
		(state: Store) => state.autoLayoutHorizontal
	);
	const deleteTask = useStore((state: Store) => state.deleteTask);
	const undo = useStore((state: Store) => state.undo);
	const redo = useStore((state: Store) => state.redo);
	const canUndo = useStore((state: Store) => state.canUndo);
	const canRedo = useStore((state: Store) => state.canRedo);
	const canDelete = useStore((state: Store) => state.canDelete);

	return (
		<div style={{ padding: '10px 0', margin: '4px 0' }}>
			<SpaceBetween direction="horizontal" size="s">
				<Button
					iconName="undo"
					onClick={undo}
					disabled={!canUndo}
					ariaLabel={`Undo (${getUndoShortcut()})`}
				>
					Undo
				</Button>
				<Button
					iconName="redo"
					onClick={redo}
					disabled={!canRedo}
					ariaLabel={`Redo (${getRedoShortcut()})`}
				>
					Redo
				</Button>
				<Button 
					iconName="remove" 
					onClick={deleteTask} 
					disabled={!canDelete}
					ariaLabel="Delete (Backspace/Delete)"
				>
					Delete
				</Button>
				<Button iconName="view-vertical" onClick={autoLayoutVertical}>
					Vertical Layout
				</Button>
				<Button iconName="view-horizontal" onClick={autoLayoutHorizontal}>
					Horizontal Layout
				</Button>
			</SpaceBetween>
		</div>
	);
}
